<app-header></app-header>
<div class="container-fluid min-vh-100">
  <div class="row">
    <div class="mainContent-col col p-0 h-100">
      @if (toasts.length > 0) {
        <div class="toast-container">
          @for (toast of toasts; track toast) {
            <app-toast [toast]="toast"></app-toast>
          }
        </div>
      }
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<app-footer></app-footer>
